<template>
    <div class="home-delivery-zones">
        <h1 class="is-size-5-mobile title">¿Llegan a mi domicilio?</h1>
        <div class="columns">
            <div class="column is-one-third">
                <google-map class="map" ref="map" name="example"></google-map>
            </div>

            <div class="column">
                <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>

                <p>Consulta si entregamos en tu zona ingresando tu dirección y clickeando buscar.</p>
                <br/>

                <b-field expanded label="Dirección" :type="errors.has('addressUserInput') ? 'is-danger' : ''" :message="errors.first('addressUserInput')">
                    <b-field>
                        <b-input expanded
                                 type="search"
                                 ref="address"
                                 v-model="addressUserInput"
                                 v-validate="'required'"
                                 placeholder="E.g. Callao 123, CABA"
                                 @keyup.enter.native="onSearchAddress">
                        </b-input>

                        <div class="control">
                            <button class="button is-primary" v-bind:class="{ 'is-loading': isLoading }" @click="onSearchAddress">Buscar</button>
                        </div>
                    </b-field>
                </b-field>

                <div v-if="deliveryZone != null" class="step-container">
                    <span v-if="!schedules && !isLoading">No hay horarios de entrega para esta dirección.</span>

                    <table v-if="schedules" class="table">
                        <tr>
                            <th></th>

                            <th v-for="(day, index) in days" :key="'thd_' + index">
                                {{ day.toLocaleDateString('es', { weekday: 'short' }) }} {{ day.getDate() }}
                            </th>
                        </tr>

                        <tr v-for="(arr, key) in schedules" :key="'schedule_' + key">
                            <td>{{ key }}</td>

                            <td class="check" v-for="(day, dindex) in days" :key="'schedule_' + key + '_' + dindex">
                                <span v-if="arr[day.getDay()]" class="icon is-medium">
                                    <i v-if="arr[day.getDay()].holiday" class="fal fa-lg fa-times"></i>
                                    <i v-else class="fal fa-lg fa-check"></i>
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /*global google*/
    import GoogleMap from '../../components/ui/GoogleMap';

    export default {
        data() {
            return {
                isLoading: false,
                addressUserInput: '',
                deliveryZone: undefined,
                schedules: null
            }
        },
        components: {
            GoogleMap
        },

        mounted() {
        },

        watch: {
            deliveryZone(zone) {
                if(zone == null) {
                    return;
                }

                // Define the LatLng coordinates for the polygon's path.
                for(let poly of zone.polygons) {
                    let latLngArr = [];

                    for(let point of poly) {
                        let c = point.split(',');
                        latLngArr.push({
                            lat: parseFloat(c[0]),
                            lng: parseFloat(c[1])
                        });
                    }

                    // Construct the polygon.
                    this.$refs.map.addPolygon({
                        paths: latLngArr,
                        strokeColor: '#FF0000',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#FF0000',
                        fillOpacity: 0.35
                    });
                }

                // Request the schedules for the selected delivery address
                this.isLoading = true;
                this.$api.getZoneSchedule(zone.id).then(response => {
                    this.schedules = {};

                    if(!response) {
                        this.isLoading = false;
                        return;
                    }

                    // Populate the days
                    let days = [];
                    let today = new Date();
                    for(let i = 1; i <= 7; i++) {
                        let day = new Date();
                        day.setDate(today.getDate() + i);
                        days.push(day);
                    }
                    this.days = days;

                    // Get unique list of schedule times
                    for(let i = 0; i < response.length; i++) {
                        let sch = response[i];
                        let t = sch.start + ' - ' + sch.end;

                        if(!this.schedules[t])
                            this.schedules[t] = [];

                        this.schedules[t][sch.day] = sch;
                    }

                    // Sort by time start
                    this.schedules = Object.keys(this.schedules).sort().reduce((r, k) => (r[k] = this.schedules[k], r), {});

                    this.isLoading = false;
                });
            }
        },

        methods: {
            onSearchAddress() {
                this.errors.clear();
                this.isLoading = true;

                this.$refs.map.clearPolygons();
                this.$refs.map.clearMarkers();

                this.deliveryZone = undefined;
                this.schedules = null;

                let address = this.$refs.address.value;

                let bounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(-35.068078, -59.219226),
                    new google.maps.LatLng(-34.260481, -57.673578));

                this.$refs.map.getAddressInfo({
                    address: address,
                    bounds: bounds,
                    componentRestrictions: {country: 'ar'}
                }).then((result) => {
                    // Set Marker
                    this.$refs.map.setMarker(result.geometry.location);
                    this.$refs.map.setCenter(result.geometry.location);

                    return this.$api.getZonesByLocation({
                        lat: result.geometry.location.lat(),
                        lng: result.geometry.location.lng()
                    });
                }).then((zone) => {
                    this.isLoading = false;

                    if(zone === null || zone.length === 0) {
                        this.deliveryZone = null;
                        this.errors.add({ field: 'addressUserInput', msg: 'Lamentablemente por el momento no entregamos en tu dirección' });
                    } else {
                        this.deliveryZone = zone;
                    }
                }).catch((err) => {
                    this.errors.add({ field: 'addressUserInput', msg: 'No podemos encontrar la dirección, verificá la dirección ingresada o intenta agregar la localidad a tu dirección (p. ej. Callao 123, CABA)' });
                    this.isLoading = false;
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .map {
        width: 100%;
        padding-top: 100%;
    }

    .green {
        color: #8fbc1b;
        font-size: 1.25rem;
    }

    .table {
        width: 100%;

        th {
            /*text-transform: uppercase;*/
        }

        td.check {
            text-align: center;
            color: $primary;
        }
    }
</style>